var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3981",
    "data-name": "Group 3981",
    transform: "translate(-255 -1075)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_964",
    "data-name": "Ellipse 964",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(255 1075)",
    fill: "#ff0300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-cash",
    "data-name": "Icon ionic-md-cash",
    transform: "translate(267.287 1087.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5262",
    "data-name": "Path 5262",
    d: "M2.25,6.75v13.1H25.174V6.75Zm8.213,11.462H6.349a2.459,2.459,0,0,0-2.461-2.461V11.662A3.278,3.278,0,0,0,7.162,8.387h3.3A7.64,7.64,0,0,0,8.8,13.3,7.64,7.64,0,0,0,10.463,18.212Zm13.074-2.461a2.474,2.474,0,0,0-2.456,2.461H16.961A7.64,7.64,0,0,0,18.624,13.3a7.64,7.64,0,0,0-1.663-4.912h3.3a3.278,3.278,0,0,0,3.275,3.275Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5263",
    "data-name": "Path 5263",
    d: "M2.25,27H25.174v1.637H2.25Z",
    transform: "translate(0 -5.513)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price_icon.7105087eba983a5333c7e6ba5377a3e6.svg";
export { ForwardRef as ReactComponent };